import PropTypes from 'prop-types';
import React, { useEffect, useRef, useState } from 'react';
import Modal from 'react-modal';
import useFunctionKeys from './hooks/useFunctionKeys';
import styled from 'styled-components';

// Background images imports
import bg1 from './img/login/bg1.jpg';
import bg2 from './img/login/bg2.jpg';
import bg3 from './img/login/bg3.jpg';
import bg4 from './img/login/bg4.jpg';
import bg5 from './img/login/bg5.jpg';
import bg6 from './img/login/bg6.jpg';
import bg7 from './img/login/bg7.jpg';
import bg8 from './img/login/bg8.jpg';
import bg9 from './img/login/bg9.jpg';
import bg10 from './img/login/bg10.jpg';

import bg11 from './img/login/bg11.jpg';
import bg12 from './img/login/bg12.jpg';
import bg13 from './img/login/bg13.jpg';
import bg14 from './img/login/bg14.jpg';
import bg15 from './img/login/bg15.jpg';
import bg16 from './img/login/bg16.jpg';
import bg17 from './img/login/bg17.jpg';
import bg18 from './img/login/bg18.jpg';
import bg19 from './img/login/bg19.jpg';
import bg20 from './img/login/bg20.jpg';
import bg21 from './img/login/bg21.jpg';
import bg22 from './img/login/bg22.jpg';
import bg23 from './img/login/bg23.jpg';
import bg24 from './img/login/bg24.jpg';

import bg25 from './img/login/bg25.jpg';
import bg26 from './img/login/bg26.jpg';
import bg27 from './img/login/bg27.jpg';
import bg28 from './img/login/bg28.jpg';
import bg29 from './img/login/bg29.jpg';
import bg30 from './img/login/bg30.jpg';

import logo from './img/sun-logo.svg';
import ifmsLogo from './img/iFMS_B.svg';
import lock from './img/ico_lock.png';
import user from './img/ico_user.png';
import { throttle } from 'lodash';
import PrimaryButton from './ui/PrimaryButton';
import QRCode from "react-qr-code";
import { User } from './ifmsTypes';
import esiLogo from './img/esi-logo.svg';
import logoSuntekAll from './img/logo_suntek_All.png';

const LoginScreen = styled.div`
.loginContainer, .contents, .box-wrap {
  width: 100%;
  height: 100%;
}

.loginContainer .box-wrap {
    position: relative;
    min-width: 320px;
    max-width: 450px;
    background-color: rgba(255,255,255,0.9);
}

.loginContainer .box {
    position: relative;
    width: 100%;
    top: 0;
    background-color: transparent;
}

.loginContainer .box .logo {
    text-align: center;
    padding: 130px 0 50px;
}

.loginContainer .box .input-custom {
    position: relative;
    width: 74%;
    margin: 0 auto;
    padding: 8px 0;
}

.loginContainer .box .input-custom .form-customize {
    position: relative;
    width: 100%;
    border: none;
    border: 2px solid #cccccc;
    box-sizing: border-box;
    padding: 15px 15px 15px 50px;
    margin: 0 auto;
    outline: none;
    z-index: 20;
    background-color: #fff;
    border-radius: 5px;
    font-size: 15px;
    line-height: 17px;
}

.loginContainer .box .form-customize:hover {
  border: 2px solid #0079A4;
}

.loginContainer .box .btn:hover {
background-color: #0079A4;
}

.loginContainer .box .input-custom .form-customize::placeholder {
  font-size: 15px !important;
}
.loginContainer .box .input-custom .form-customize::-webkit-input-placeholder {
  font-size: 15px !important;
}
.loginContainer .box .input-custom .form-customize::-moz-placeholder {
  font-size: 15px !important;
}
.loginContainer .box .input-custom .form-customize::-ms-input-placeholder {
  font-size: 15px !important;
}

.loginContainer .box .input-custom .ico_login {
    position: absolute;
    left: 11px;
    top: 19px;
    width: 30px;
    height: 30px;
    background-position: center;
    background-repeat: no-repeat;
    background-size: 20px 20px;
    z-index: 30;
    opacity: 0.7
}

.loginContainer .box .input-custom .ico_account {
    background-image: url(../images/iCons/ico_account.png);
}

.loginContainer .box .input-custom .ico_user {
    background-image: url(../images/iCons/ico_user.png);
}

.loginContainer .box .input-custom .ico_pwd {
    background-image: url(../images/iCons/ico_lock.png);
}

.loginContainer .box .checkbox {
    width: 150px;
    margin: 0 auto;
    padding:25px 0;
    color:#000;
}

.loginContainer .box .btn {
    padding: 15px 0;
    width: 74%;
    position: absolute;
    left: 13%;
    outline: none;
    background-color: #E28212;
    border: none;
    color: #ffffff;
    font-weight: 500;
    margin: 12px 0 0;
    border-radius: 3px;
    cursor: pointer;
    line-height: 17px;
}

@media screen and (min-width:450px) {
  .loginContainer .box-wrap {
      position: fixed;
      left: 50%;
      margin-left: -225px;
  }
}

@media screen and (max-width:767px) {
  body form {
      background-color: #464646;
  }
}

@media screen and (min-width:768px) {
  .loginContainer .box-wrap {
      position: fixed;
      left: 23%;
  }
}
`;

const SubLogo = styled.div`
.sublogo-wrap {position: relative;}
.sublogo-wrap .suntek_logo {position: fixed;right: 50%;bottom: 0;margin-right: -15%;width:30%; margin-bottom:0.8%;}
.sublogo-wrap .suntek_logo>img{width: 100%;}

@media screen and (max-width:449px){
.sublogo-wrap {display: none;}

}

@media screen and (min-width:450px) {
  .sublogo-wrap .suntek_logo {
    width:30%;
    margin-right: -15%;
  }
}

@media screen and (min-width:768px) {
  .sublogo-wrap .suntek_logo {
    width:15%;
    right:15px;
    margin-right: 0;
    min-width:270px;
  }
}
`;

// const bgImages = [bg1, bg2, bg3, bg4, bg5, bg6, bg7, bg8, bg9, bg10];
// const bgImages = [bg11, bg12, bg13, bg14, bg15, bg16, bg17, bg18, bg19, bg20, bg21, bg22, bg23, bg24];
const bgImages = [bg25, bg26, bg27, bg28, bg29, bg30];

const ModalContentStyle:React.CSSProperties = {
  top: '13%',
  left: '38%',
  right: 'auto',
  bottom: 'auto',
  zIndex: 10000,
  width: '700px',
};
const ModalContentStyle2:React.CSSProperties = {
  top: '35%',
  left: '38%',
  right: 'auto',
  bottom: 'auto',
  zIndex: 10000,
  width: '400px',
};
const ModalOverlayStyle:React.CSSProperties = {
  position: 'fixed',
  top: 0,
  left: 0,
  right: 0,
  bottom: 0,
  backgroundColor: 'rgba(0, 0, 0, 0.55)',
  zIndex: 999998,
};



type Props = {
  onLogin: (username: string, password: string, rememberMe: boolean, urlPrefix:string) 
      => Promise<{ success: boolean; user: any; errorMessage: string | null; } | undefined>,
    fineOtherTabLogin: (username: string) => Promise<boolean>,
    //2fa
    suntekUser: User| undefined,
    suntekAdmin2FAActive:boolean,
    do2FAActive: (username:string, password:string, code: string) => Promise<string>,
    suntekAdminVerify:boolean,
    doSuntekAdminAuth: (username:string, password:string, code: string) => Promise<string>,
    on2FAActiveCancel: () => void,
    onSuntekAdminAuthCancel: () => void,
};

const Login: React.FC<Props> = ({ onLogin, fineOtherTabLogin, 
  //2fa
  suntekUser,
  suntekAdmin2FAActive,
  do2FAActive,
  suntekAdminVerify,
  doSuntekAdminAuth,
  on2FAActiveCancel, onSuntekAdminAuthCancel
}) => {
  useFunctionKeys({ onEnter });
  const enter = 13;

  const [bgIndex] = useState(Math.floor(Math.random() * bgImages.length));

  const [email, _setEmail] = useState<string>('');
  //const [emailDirty, setEmailDirty] = useState<boolean>(false);
  const [password, _setPassword] = useState<string>('');
  //const [passwordDirty, setPasswordDirty] = useState<boolean>(false);
  const [rememberMe, _setRememberMe] = useState<boolean>(false);
  const [errorMessage, setErrorMessage] = useState<string>('');

  const emailRef = useRef<string>('');
  const passwordRef = useRef<string>('');
  const rememberRef = useRef<boolean>(false);
  const [boxMarginTop, setBoxMarginTop] = useState(setMarginTop());
  const [iconBoxMarginTop, seticonBoxMarginTop] = useState(setIconMarginTop());
  const handleResize = throttle(() => {
    setBoxMarginTop(setMarginTop());
    seticonBoxMarginTop(setIconMarginTop());
  }, 200);

  //<240808.dwshin. Suntek Admin ID Pattern Update - 2FA Add
  const [verifycode, _setVerifycode] = useState<string>('');
  const [veriftErrorMsg, setVeriftErrorMsg] = useState<string>('');
  const [authcode, _setAuthcode] = useState<string>('');
  const [authErrorMsg, setAuthErrorMsg] = useState<string>('');
  //240808.dwshin>

  useEffect(() => {
    window.addEventListener("resize", handleResize);
    return () => {
      // cleanup
      window.removeEventListener("resize", handleResize);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  function setIconMarginTop() {
    let result = window.innerHeight - 650;

    if (result < 0) result = 0;
    result += 10;
    if (result > 140) result = 140;

    return result;
  }

  function setMarginTop() {
    let result = window.innerHeight - 800;

    if (result < 0) result = 0;
    else if (result > 170) result = 170;

    return result;
  }

  function setEmail(v: string) {
    emailRef.current = v;
    _setEmail(v);
    setErrorMessage('');
  }

  function setPassword(v: string) {
    passwordRef.current = v;
    _setPassword(v);
    setErrorMessage('');
  }

  function setRememberMe(v: boolean) {
    rememberRef.current = v;
    _setRememberMe(v);
  }

  useEffect(() => {
    const focusElement = document.getElementById('email');
    if (focusElement) {
      focusElement.focus();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // function onPwdBlur(e: React.FocusEvent) {
  //   e.preventDefault();
  //   setPassword(passwordRef.current);
    
  //   const passwordcmp = document.getElementById('password') as HTMLInputElement;
  //   passwordcmp.value = '';

  //  passwordcmp.setAttribute('value','')

  // }

  async function doLogin() {

    let preIndex  = 0;
    if(window.location.host.indexOf('-ifms.suntekscm') > -1){
      preIndex = window.location.host.toLowerCase().indexOf("-ifms.suntekscm.co");
      const canLogin = preIndex > 0;
      if (!canLogin) {
        setErrorMessage('Invalid Site');
        return;
      }
    }
    
    const result = await fineOtherTabLogin(emailRef.current);
    if(!result){
      setErrorMessage('Already logged in.');
      return;
    }
    let urlPrefix = window.location.host.substring(0, preIndex);

    const apiResult = await onLogin(emailRef.current, passwordRef.current, rememberRef.current, urlPrefix);
    if (apiResult && apiResult.success) {
      setErrorMessage('');
      return;
    }

    if (apiResult) {
      let msg = null;
      if(typeof apiResult.user?.errors === 'string'){
        msg = apiResult.user?.errors;
      }

      setErrorMessage(msg ?? apiResult.user?.errors.message ?? apiResult.errorMessage ?? '');
    }
  }

  function handleEmailChange(e: React.ChangeEvent<HTMLInputElement>) {
    setEmail(e.target.value);
    //setEmailDirty(true);
  }

  function handlePasswordChange(e: React.ChangeEvent<HTMLInputElement>) {
    setPassword(e.target.value);
    //setPasswordDirty(true);
  }

  //<240808.dwshin. Suntek Admin ID Pattern Update - 2FA Add
  function handleVerifycodeChange(e: React.ChangeEvent<HTMLInputElement>) {
    _setVerifycode(e.target.value);
  }
  function handleAuthcodeChange(e: React.ChangeEvent<HTMLInputElement>) {
    _setAuthcode(e.target.value);
  }
  //240808.dwshin.>


  function onEnter(): boolean {
    const email = document.getElementById('email')
    if (email && email === document.activeElement) {

      const password = document.getElementById('password') as HTMLInputElement;
      if (password) {
        password.focus();
        password.select();
      }
    } else {
      doLogin();
    }

    return true;
  }

  async function on2FAActive() {
    setVeriftErrorMsg('');
    
    if (verifycode) {
      if(isNaN(parseInt(verifycode.replaceAll('-', '')))){
        setVeriftErrorMsg('Verification code is invalid.');
      }

      let errorMsg = await do2FAActive(emailRef.current, passwordRef.current, verifycode);
      if (errorMsg) {
        setVeriftErrorMsg(errorMsg);
      }
    }
  }
  
  async function onSuntekAdminAuth() {
    setAuthErrorMsg('');
    
    if (authcode) {
      if(isNaN(parseInt(authcode.replaceAll('-', '')))){
        setAuthErrorMsg('Verification code is invalid.');
      }

      let errorMsg = await doSuntekAdminAuth(emailRef.current, passwordRef.current, authcode);
      if (errorMsg) {
        setAuthErrorMsg(errorMsg);
      }
    }

  }


  var bgImage = bgImages[bgIndex];

  return (
    <LoginScreen style={{ width: '100%', height: '100%' }}>
      <div className="loginContainer" style={{ backgroundImage: `url(${bgImage})`, backgroundSize: 'cover', backgroundRepeat: 'no-repeat', padding: 0, backgroundPosition: 'center' }}>
        <div className="contents">
          <div className="box-wrap">
            <div className="box" style={{ paddingTop: `${boxMarginTop}px` }}>
              {/* <div className="logo"><img src={ifmsLogo} alt="" /></div> */}
              <div className="logo"><div style={{fontWeight: 'bold', fontSize: '45px', color:'purple'}}>Orchid CMS<sup>&reg;</sup></div></div>
              <div className="input-custom input-userId">
                <span className="ico_login ico_user" style={{ backgroundImage: `url(${user})` }}></span>
                <input
                  className="form-customize"
                  type="text"
                  id="email"
                  name="email"
                  data-msg-containerid="mailError"
                  value={email}
                  onChange={handleEmailChange}
                  placeholder="User ID"
                  autoComplete="off"
                  list="suntek-scm-login-email"
                />
                {/* {(emailDirty && !email) &&
                <label className="error-label" htmlFor="email">* Enter your email address</label>
                } */}
              </div>
              <div className="input-custom input-pwd">
                <span className="ico_login ico_pwd" style={{ backgroundImage: `url(${lock})` }}></span>
                <input
                  className="form-customize"
                  type="password"
                  id="password"
                  name="password"
                  data-msg-containerid="passwordError"
                  value={password}
                  onChange={handlePasswordChange}
                  placeholder="Password"
                  autoComplete="off"
                  list="suntek-scm-login-psw"
                  //readOnly
                  //onFocus={e => e.target.removeAttribute('readonly')}
                  //onBlur={onPwdBlur}
                />
                {/* {(passwordDirty && !password) &&
                <label className="error-label" htmlFor="password">* Enter your password</label>
                } */}
              </div>
              <div className="checkbox">
                <input type="checkbox" checked={rememberMe} onChange={e => setRememberMe(e.target.checked)} /><label style={{ display: 'inline', marginLeft: '11px' }}>Remember me?</label>
              </div>

              <div id="errorMsg" style={{ textAlign: 'center', margin: '0 0 15px', }}>
                <label id="Error" style={{ color: '#ff3232', fontWeight: 'bold', margin: 0 }}>{errorMessage}</label>
              </div>
              <div style={{ height: '20px' }}>
                {/* <button type="submit" onClick={doLogin} className="btn">Login to your Account</button> */}
                <PrimaryButton className="btn" onClick={doLogin} >Login to your Account</PrimaryButton>
              </div>

              <div style={{ marginTop: `${iconBoxMarginTop}px`, textAlign: 'center' }}>
                <img style={{ height: '90px' }} src={esiLogo} alt="Esi" />
              </div>
              <div>

              </div>
            </div>
          </div>
        </div>
        {/* <SubLogo>
          <div className= "sublogo-wrap"> 
            <h2 className="logo-suntek-wrap">
              <p className='suntek_logo'>
                <img src={logoSuntekAll} alt="" />  
              </p>
            </h2>     
          </div>
        </SubLogo> */}
      </div>

      <Modal
        isOpen={suntekAdmin2FAActive}
        shouldCloseOnOverlayClick={false}
        shouldCloseOnEsc={false}
        contentLabel=""
        style={{
          overlay: ModalOverlayStyle,
          content: ModalContentStyle
        }}
      >
        <p>Your login is protected with two-factor authentication, 
        please go through the following steps:</p>
        <ol className="list" style={{width:'628px'}}>
          <li>
            <p>
              <b>Download a two-factor authenticator app</b> like Microsoft Authenticator for&nbsp;
              <a target="_blank" rel="noreferrer" href="https://go.microsoft.com/fwlink/?Linkid=825071">Windows Phone</a>,&nbsp;
              <a target="_blank" rel="noreferrer" href="https://go.microsoft.com/fwlink/?Linkid=825072">Android</a> and&nbsp;
              <a target="_blank" rel="noreferrer" href="https://go.microsoft.com/fwlink/?Linkid=825073">iOS</a> or
              Google Authenticator for&nbsp;
              <a target="_blank" rel="noreferrer" href="https://play.google.com/store/apps/details?id=com.google.android.apps.authenticator2&amp;hl=en">Android</a> and&nbsp;
              <a target="_blank" rel="noreferrer" href="https://itunes.apple.com/us/app/google-authenticator/id388497605?mt=8">iOS</a>.
            </p>
          </li>
          {suntekUser && suntekUser.authenticatorUri &&
            <li>
              <p><b>Scan the QR Code</b> or enter this key <kbd>{suntekUser.sharedKey}</kbd> into your two factor authenticator app. Spaces and casing do not matter.</p>
              <QRCode
                size={256}
                style={{ height: "auto", width: "120px" }}
                value={suntekUser.authenticatorUri}
                viewBox={`0 0 256 256`}
              />
            </li>
          }
          <li>
            <p>
              Once you have scanned the QR code or input the key above, your two factor authentication app will provide you
              with a unique code.<br />
              Enter 6 digit OTP code in the confirmation box below.
            </p>
            <div className="row">
              <div className="col-md-6">
                <label className="control-label">Verification Code</label>
                <input className="form-customize" type="text"
                  id="verifycode"
                  name="verifycode"
                  value={verifycode}
                  onChange={handleVerifycodeChange}
                  onKeyDown={(e) => {
                    if (e.keyCode === enter) {
                      on2FAActive();
                      e.preventDefault();
                      e.stopPropagation();
                    }
                  }}
                  autoComplete="off"
                  list="suntek-scm-login-verifycode"
                />
              </div>
            </div>
          </li>
        </ol>

        <div id="verify-button" style={{ margin: '0 0 0 40px', }}>
          <PrimaryButton className="loginbtn-auth" onClick={on2FAActive}>Verify</PrimaryButton>
          <PrimaryButton className="btn" onClick={() => {
            _setVerifycode('');
            on2FAActiveCancel();
            }} style={{margin: '0 0 0 8px'}} >
              Cancel</PrimaryButton>
        </div>
        <div id="veriftErrorMsg" style={{ textAlign: 'center', margin: '0 0 15px', }}>
          <label id="Error" style={{ color: '#ff3232', fontWeight: 'bold', margin: 0 }}>{veriftErrorMsg}</label>
        </div>
      </Modal>

      <Modal
        isOpen={suntekAdminVerify}
        shouldCloseOnOverlayClick={false}
        shouldCloseOnEsc={false}
        contentLabel=""
        style={{
          overlay: ModalOverlayStyle,
          content: ModalContentStyle2
        }}
      >
        <p>Your login is protected with an authenticator app.<br /> Enter your authenticator code below.</p>
          <div className="row">
            <div className="col-md-6">
              <label className="control-label">Authenticator code</label>
              <input className="form-customize" type="text"
                id="authcode"
                name="authcode"
                value={authcode}
                onChange={handleAuthcodeChange}
                onKeyDown={(e) => {
                  if (e.keyCode === enter) {
                    onSuntekAdminAuth();
                    e.preventDefault();
                    e.stopPropagation();
                  }
                }}
                autoComplete="off"
                list="suntek-scm-login-verifycode"
              />
            </div>
          </div>

        <div id="auth-button" style={{ margin: '10px 0 3px 3px' }}>
          <PrimaryButton className="loginbtn-auth" onClick={onSuntekAdminAuth}>Login</PrimaryButton>
          <PrimaryButton className="btn" onClick={() => {
              _setAuthcode('');
              onSuntekAdminAuthCancel();
            }} style={{margin: '0 0 0 8px'}}>Cancel</PrimaryButton>
        </div>
        <div id="authErrorMsg" style={{ textAlign: 'center', margin: '0 0 15px', }}>
          <label id="Error" style={{ color: '#ff3232', fontWeight: 'bold', margin: 0 }}>{authErrorMsg}</label>
        </div>
      </Modal>

    </LoginScreen>
  );
};

Login.propTypes = {
  onLogin: PropTypes.func.isRequired,
};
export default Login;
